export type SchemaNode = {
  id?: string;
  category?: string;
  children?: SchemaNode | SchemaNode[];
  [key: string]: unknown;
};

export const isSchemaNode = (value: unknown): value is SchemaNode =>
  typeof value === 'object' && value !== null;

export type JSONMapPointer = {
  key?: { line: number; column: number; pos: number };
  keyEnd?: { line: number; column: number; pos: number };
  value?: { line: number; column: number; pos: number };
  valueEnd?: { line: number; column: number; pos: number };
};

export type JSONMap = {
  data: unknown;
  pointers: Record<string, JSONMapPointer>;
};

export const getValueAtPointer = (data: unknown, pointer: string): unknown => {
  if (pointer === '') return data;

  const parts = pointer.split('/').filter(Boolean);

  return parts.reduce((current: unknown, part) => {
    if (current && typeof current === 'object') {
      const key = part.replace(/~1/g, '/').replace(/~0/g, '~');
      return (current as Record<string, unknown>)[key];
    }
    return current;
  }, data);
};
